import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { RateModelDto } from "../ratemodeldto";
import { GeneralDiscountCatalogDto } from "./GeneralDiscountCatalogDto.model";

export class IdOwnRateDiscountDto {
    idOwnRateDiscount?: number;
    rateType?: string;
    rateId?: number;
    discountPercentage?: number;
    fixedDiscountAmount?: number;
    discountOrderNumber?: number;
    startDate?: string;
    endDate?: string;
    rateModelDto?: RateModelDto;
    generalDiscountCatalogDto? : GeneralDiscountCatalogDto

    constructor(data?: Partial<IdOwnRateDiscountDto>) {
        Object.assign(this, data);
    }
}

export class GeneralDiscountCatalogResponse {
    GeneralDiscountCatalogDto: GeneralDiscountCatalogDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class GeneralDiscountCatalogRequest {
    GeneralDiscountCatalogDto: GeneralDiscountCatalogDto = new GeneralDiscountCatalogDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}

export class IdOwnRateDiscountDtoResponse {
    IdOwnRateDiscountDto: IdOwnRateDiscountDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class IdOwnRateDiscountDtoRequest {
    IdOwnRateDiscountDto: IdOwnRateDiscountDto = new IdOwnRateDiscountDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}